import React from 'react';

class TOCHModal extends React.Component {
    render() {
        const {
            handleOnClose
        } = this.props;

        return (
            <div className="modal modal--mobile-fixed modal-mastercard-registration is-opened" data-modal>
                <div className="modal__container-wrapper">
                    <div className="modal__container">
                        <div data-modal-wrapper className="modal__wrapper">
                            <button data-modal-close type="button" className="modal__close" aria-label="close" onClick={() => handleOnClose(false)}>
                                <svg className="icon" width="10" height="10" focusable="false">
                                    <use xlinkHref="#icon-cross"></use>
                                </svg>
                            </button>
                            <div className="modal__content" data-modal-content>
                                <div className="modal-content">
                                    <div className="modal-body">
                                        {this.props.children}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default TOCHModal;
